export const Loader = ({ done }: { done: boolean }) => {
	return (
		<div className={`nh-loader${done ? " is-done" : ""}`} aria-hidden="true">
			<img
				src="/assets/nh-wordmark.svg"
				alt=""
				width={30}
				height={252}
				draggable={false}
			/>
		</div>
	);
};
